import { render, staticRenderFns } from "./UsulanPerubahanViewNew.vue?vue&type=template&id=b571b362&scoped=true&lang=pug&"
import script from "./UsulanPerubahanViewNew.vue?vue&type=script&lang=js&"
export * from "./UsulanPerubahanViewNew.vue?vue&type=script&lang=js&"
import style0 from "./UsulanPerubahanViewNew.vue?vue&type=style&index=0&id=b571b362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b571b362",
  null
  
)

export default component.exports